import { createAction } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { AuthApiActionTypes } from './types';

export const setAccessToken = createAction<{ accessToken: string | undefined }>(
  AuthApiActionTypes.SetAccessToken,
);

export const refreshTokenFailed = createAction<{
  error: FetchBaseQueryError | undefined;
  status: FetchBaseQueryError['status'] | undefined;
}>(AuthApiActionTypes.RefreshTokenFailed);
